import { Component, Input, OnInit } from '@angular/core';
import { RxjsService } from '@app/shared/services';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class AppLoaderComponent implements OnInit {
  @Input() isLoading = false;
  color = 'primary';
  mode = 'indeterminate';
  private readonly completed$ = new Subject();

  constructor(private rxjsService: RxjsService) {
  }

  ngOnInit() {
    this.rxjsService.getGlobalLoaderProperty().pipe(takeUntil(this.completed$)).subscribe((isLoading) => {
      this.isLoading = isLoading;
    });
  }

  ngOnDestroy() {
    this.completed$.next(null);
    this.completed$.complete();
  }
}